import { Image } from '@tryhackme/thm-ui-components';
import { useCallback } from 'react';
import { StyledLoading } from 'src/common/components';
import { Achievement, type SocialLinks, SocialName } from 'src/common/page-share';
import { socialTrackEvents } from 'src/common/page-share/page-share.constants';
import { useSocialLinks } from 'src/common/page-share/use-social-links';
import { useTrackEventMutation } from 'src/common/slices';
import { StyledSocialButton } from 'src/common/styles';
import type { SegmentShareEvent } from 'src/common/types';
import type { RoomDetailsData } from 'src/features/room/room.types';
import { StyledContentWrapper, StyledSubTitle, StyledTitle } from '../../congratulations-full-screen.styles';
import { StyledGridWrapper, StyledSocialButtonsWrapper, StyledSocialImageWrapper } from './sharing-step.styles';
export const SharingStep = ({
  currentRoom,
  isLoading,
  socialLinks = {
    [SocialName.twitter]: true,
    [SocialName.facebook]: true,
    [SocialName.linkedin]: true
  }
}: {
  currentRoom?: RoomDetailsData;
  isLoading: boolean;
  socialLinks?: SocialLinks;
}) => {
  const [trackEvent] = useTrackEventMutation();
  const filteredLinks = useSocialLinks(socialLinks);
  const trackShareClick = useCallback((event: SegmentShareEvent) => {
    const source = event.split('-')[1];
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'social-share',
      properties: {
        achievement: Achievement.room,
        page: 'room',
        name: currentRoom?.code,
        medium: source,
        clicked_on: source
      }
    });
  }, [trackEvent, currentRoom?.code]);
  return <StyledContentWrapper data-content="social-sharing" data-sentry-element="StyledContentWrapper" data-sentry-component="SharingStep" data-sentry-source-file="sharing-step.tsx">
      <header>
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="sharing-step.tsx">
          Demonstrate your expertise and stand out in the <br />
          cyber security community!
        </StyledTitle>
        <StyledSubTitle data-sentry-element="StyledSubTitle" data-sentry-source-file="sharing-step.tsx">Boost your visibility and highlight your dedication to professional growth.</StyledSubTitle>
      </header>
      <StyledGridWrapper gridTemplateColumns="51.3rem 1fr" justifyContent="center" gap="4.6rem" alignItems="center" data-sentry-element="StyledGridWrapper" data-sentry-source-file="sharing-step.tsx">
        {isLoading ? <>
            <StyledLoading width="50.1rem" height="35.9rem" />
            <StyledLoading width="20rem" height="24rem" />
          </> : <>
            <StyledSocialImageWrapper>
              <>
                <Image src={currentRoom?.imageURL ?? ''} width="513" alt="room image" loading="lazy" />
                <figcaption>
                  <h3>{currentRoom?.title}</h3>
                  <p>tryhackme.com - 1 min read</p>
                </figcaption>
              </>
            </StyledSocialImageWrapper>
            <StyledSocialButtonsWrapper>
              {filteredLinks.map(social => <StyledSocialButton key={social.name} data-social={social.name === SocialName.twitter ? 'twitter-x' : social.name} href={social.href({
            description: 'Share your achievement',
            url: `https://tryhackme.com/room/${currentRoom?.code ?? ''}`,
            campaign: {
              utmContent: 'room'
            }
          })} target="_blank" onClick={() => trackShareClick(socialTrackEvents[social.name])}>
                  <social.icon />
                  {social.officialName}
                </StyledSocialButton>)}
            </StyledSocialButtonsWrapper>
          </>}
      </StyledGridWrapper>
    </StyledContentWrapper>;
};